import {
  Stack,
  Box,
  Tabs,
  TabList,
  Tab,
  TabPanel,
  TabPanels,
  Text,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";
// import colors from "common/theme/foundations/colors";
import "services/Recruit/assets/css/CreateJobOpening/style.css";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { ArrowBackIcon } from "@chakra-ui/icons";

const TabPanelsComponent = ({
  panelsData,
  handleNext,
  handleBack,
  activeTabIndex,
  id,
}) => {
  return (
    <TabPanels w={"60%"} className="createJobOpening-tabsPanelContainer">
      {panelsData.map((content, index) => (
        <TabPanel key={index} className="createJobOpening-tabsPanel">
          <Box className="createJobOpening-tabsPanelBody commonComp">{content}</Box>
          {/* <Box className="createJobOpening-tabsPanelFooter">
            {activeTabIndex > 0 && (
              <Button
                className="backBtn"
                variant="secondary"
                onClick={handleBack}
              >
                {constant.back}
              </Button>
            )}
            {activeTabIndex < panelsData.length - 1 ? (
              <Button
                className="nextBtn"
                variant="primary"
                onClick={handleNext}
              >
                {constant.next}
              </Button>
            ) : (
              <Button
                className="nextBtn"
                variant="primary"
                onClick={handleSubmitForm}
              >
                {id ? constant.update : constant.save}
              </Button>
            )}
          </Box> */}
        </TabPanel>
      ))}
    </TabPanels>
  );
};

const CreateTabs = ({ tabsData, panelsData, id,handleBackPage,pageTitle }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const colors = globalStyles.colors;

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
  };

  const handleNext = () => {
    if (activeTabIndex < tabsData.length - 1) {
      setActiveTabIndex(activeTabIndex + 1);
    }
  };

  const handleBack = () => {
    if (activeTabIndex > 0) {
      setActiveTabIndex(activeTabIndex - 1);
    }
  };

  return (
    <Stack>
      <Box className="createJobOpening-container">
        <Box className="createJobOpening-mainContainer">
          <Box className="createJobOpening-breadCrumb">
            <ArrowBackIcon
              onClick={handleBackPage}
              fontSize="20px"
              cursor={"pointer"}
            />
            <Text className="createJobOpening-pageTitle">
              {pageTitle}
            </Text>
          </Box>
        </Box>
        <Tabs
          index={activeTabIndex}
          onChange={handleTabChange}
          className="createJobOpening-tabsContainer"
          variant="unstyled"
          orientation="vertical"
        >
          <TabList w={"40%"} className="createJobOpening-tabListContainer">
            {tabsData.map(({ label, Icon }, index) => (
              <Tab
                className="createJobOpening-tabs"
                key={index}
                _selected={{
                  color: colors.cta["100"],
                  borderLeft: "2px solid",
                  borderColor: colors.cta["100"],
                }}
                _hover={{
                  color: colors.cta["100"],
                }}
                _focus={{ boxShadow: "none" }}
                display="flex"
                alignItems="center"
                gap="8px"
              >
                <Icon size={20} />
                {label}
              </Tab>
            ))}
          </TabList>
          <TabPanelsComponent
            panelsData={panelsData}
            handleNext={handleNext}
            handleBack={handleBack}
            activeTabIndex={activeTabIndex}
            id={id}
          />
        </Tabs>
      </Box>
    </Stack>
  );
};

export default CreateTabs;
